import DiffedElement from 'app/slate/components/DiffedElement';
import DiffedLeaf from 'app/slate/components/DiffedLeaf';
const withSideBySide =
  (options = {}) =>
  (editor) => {
    const { renderElement, renderLeaf } = editor;
    const { side, readOnly } = options;
    editor.renderElement = (props) => {
      return <DiffedElement {...props} readOnly={readOnly} side={side} renderElement={renderElement} />;
    };
    editor.renderLeaf = (props) => {
      return <DiffedLeaf {...props} side={side} renderLeaf={renderLeaf} />;
    };
    return editor;
  };
export default withSideBySide;
